<template>
  <div class="module-sub-qa">
    <div class="module-sub-qa-q">
      <div class="module-sub-qa-q-left">
        <Avatar
          username="default"
          :size="60"
        ></Avatar>
      </div>
      <div class="module-sub-qa-q-middle">
        <ReadMoreText :text="data.q.desc"></ReadMoreText>
      </div>
      <div class="module-sub-qa-q-right">{{data.q.createdAt}}</div>
    </div>
    <div class="module-sub-qa-a">
      <div class="module-sub-qa-a-left">
        <Avatar
          username="default"
          :size="60"
        ></Avatar>
      </div>
      <div class="module-sub-qa-a-middle">
        <div>
          <span class="module-sub-qa-a-middle-name">{{data.a.name}}</span>
          <span class="module-sub-qa-a-middle-title">{{data.a.title}}</span>
        </div>
        <ReadMoreText class="module-sub-qa-a-middle-desc" :text="data.a.desc"></ReadMoreText>
      </div>
      <div class="module-sub-qa-a-right">{{data.a.createdAt}}</div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import { ReadMoreText } from '@/components'
export default {
  components: {
    Avatar,
    ReadMoreText
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    indexClass () {
      if (this.data.index % 2) {
        return 'module-sub-media-index-odd'
      }
      return 'module-sub-media-index-even'
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.module-sub-qa {
  display: inline-block;
  padding-top: 35px;
  margin-left: 53px;
  & .module-sub-qa-q {
    position: relative;
    min-height: 60px;
    & .module-sub-qa-q-left {
      width: 88px;
      float: left;
    }
    & .module-sub-qa-q-middle {
      padding-left: 88px;
      padding-right: 194px;
    }
    & .module-sub-qa-q-right {
      position: absolute;
      right: 0;
      top: 0;
      margin-right: 44px;
      color: var(--colorDisabled);
    }
  }
  & .module-sub-qa-a {
    position: relative;
    padding-top: 20px;
    margin-left: 88px;

    min-height: 60px;

    padding-bottom: 34px;
    border-bottom: 1px solid var(--colorDisabled);
    & .module-sub-qa-a-left {
      width: 88px;
      float: left;
    }
    & .module-sub-qa-a-middle {
      padding-left: 88px;
      padding-right: 194px;

      & .module-sub-qa-a-middle-name {
        font-weight: bold;
        color: var(--colorMain);
      }
      & .module-sub-qa-a-middle-title {
        color: var(--colorGray1);
      }
      & .module-sub-qa-a-middle-desc {
        color: var(--colorGray0);
        padding-top: 15px;
      }
    }
    & .module-sub-qa-a-right {
      position: absolute;
      right: 0;
      top: 0;
      margin-right: 44px;
      color: var(--colorDisabled);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/sub/Qa.vue